import Vue from 'vue'
import VueRouter from 'vue-router'
import {getToken} from "../common/storage";
import auth from "../common/auth";

Vue.use(VueRouter)

const routes = [
  {
    path: '/dl/:alias',
    name: 'Frame',
    component: () => import(/* webpackChunkName: "dl" */ '../views/Frame.vue'),
    meta: {
      notAuth: true
    }
  },
  {
    path: '/rp/:alias',
    name: 'Page',
    component: () => import(/* webpackChunkName: "dl" */ '../views/Page.vue'),
    meta: {
      notAuth: true
    }
  },
  {
    path: '/ac/:alias',
    component: () => import(/* webpackChunkName: "ac" */ '../views/Sch.vue'),
    children: [
      {
        path: '',
        name: 'SchHome',
        component: () => import(/* webpackChunkName: "ach" */ '../views/SchHome.vue'),
      },
      {
        path: 'enroll/:index',
        name: 'SchEnroll',
        component: () => import(/* webpackChunkName: "ace" */ '../views/SchEnroll.vue'),
      }
    ]
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "auth" */ '../views/Auth'),
    meta: {
      notAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  Vue.$showLoading();
  /* 路由发生变化修改页面title */
  let meta = to.meta;
  if (meta.title) {
    document.title = meta.title;
  }
  if(!to.meta.notAuth && !getToken()) {
    console.log('need auth');
    auth();
  } else {
    next();
  }
});
router.afterEach(() => {
  Vue.$hideLoading();
});

//Loading chunk failed 兼容解决
router.onError((error) => {
  const pattern = /Loading chunk (\S)+ failed/g;
  const isChunkLoadFailed = pattern.test(error.message);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router
